import { render, staticRenderFns } from "./FourPage.vue?vue&type=template&id=0f1eade7&scoped=true&"
import script from "./FourPage.vue?vue&type=script&lang=js&"
export * from "./FourPage.vue?vue&type=script&lang=js&"
import style0 from "./FourPage.vue?vue&type=style&index=0&id=0f1eade7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1eade7",
  null
  
)

export default component.exports